import { render, staticRenderFns } from "./change-stock-owner.vue?vue&type=template&id=6134564a&scoped=true"
import script from "./change-stock-owner.vue?vue&type=script&lang=js"
export * from "./change-stock-owner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6134564a",
  null
  
)

export default component.exports